// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PolicyTermsRouteImport } from './routes/policy.terms'
import { Route as PolicyPrivacyRouteImport } from './routes/policy.privacy'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MenuRoute = MenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PolicyTermsRoute = PolicyTermsRouteImport.update({
            id: '/policy/terms',path: '/policy/terms',getParentRoute: () => rootRouteImport
          })
const PolicyPrivacyRoute = PolicyPrivacyRouteImport.update({
            id: '/policy/privacy',path: '/policy/privacy',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,ContactRoute: ContactRoute,MenuRoute: MenuRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,PolicyPrivacyRoute: PolicyPrivacyRoute,PolicyTermsRoute: PolicyTermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)